import React, { CSSProperties } from "react";
import { ContentSection, GridRow, GridColumn, Grid } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { NoteItem } from "../hooks/state/NoteItem";
import { useNotesState } from "../hooks/state/useNotesState";
import { NotesForm } from "./NotesForm";
import { NotesList } from "./NotesList";

export const NotesSection: React.FC = () => {
    const { notes, isLoading, isInlineCreateSupported, style, isHeader, accessRights } = useNotesState();

    if (!isHeader) {
        return (
            <Grid isLoading={isLoading} style={style as CSSProperties}>
                <NoteGrid isInlineCreateSupported={isInlineCreateSupported} notes={notes} accessRights={accessRights} />
            </Grid>
        );
    }

    return (
        <ContentSection header="Notes" isLoading={isLoading} style={style}>
            <NoteGrid isInlineCreateSupported={isInlineCreateSupported} notes={notes} accessRights={accessRights} />
        </ContentSection>
    );
};

interface NoteGridProps {
    notes: NoteItem[];
    isInlineCreateSupported: boolean;
    accessRights: SprintAccessRight[];
}

const NoteGrid: React.FC<NoteGridProps> = ({ notes, isInlineCreateSupported, accessRights }) => {
    return (
        <Grid style={{ maxHeight: 350 }}>
            <GridRow style={{ minHeight: 200 }}>
                {notes.length > 0 && (
                    <GridColumn sm={12}>
                        <NotesList />
                    </GridColumn>
                )}
            </GridRow>
            <GridRow>
                {isInlineCreateSupported && (
                    <AuthorizationWrapper accessRights={accessRights}>
                        <NotesForm />
                    </AuthorizationWrapper>
                )}
            </GridRow>
        </Grid>
    );
};
